import _toConsumableArray from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Select/select';
import badgeStyles from '@patternfly/react-styles/css/components/Badge/badge';
import formStyles from '@patternfly/react-styles/css/components/FormControl/form-control';
import buttonStyles from '@patternfly/react-styles/css/components/Button/button';
import { css } from '@patternfly/react-styles';
import TimesCircleIcon from '@patternfly/react-icons/dist/js/icons/times-circle-icon';
import { SelectMenu } from './SelectMenu';
import { SelectOption } from './SelectOption';
import { SelectToggle } from './SelectToggle';
import { SelectContext, SelectVariant, SelectDirection, KeyTypes } from './selectConstants';
import { Chip, ChipGroup } from '../ChipGroup';
import { keyHandler, getNextIndex, getOUIAProps } from '../../helpers';
import { Divider } from '../Divider'; // seed for the aria-labelledby ID

var currentId = 0;
export var Select =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select() {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).apply(this, arguments));
    _this.parentRef = React.createRef();
    _this.filterRef = React.createRef();
    _this.refCollection = [];
    _this.state = {
      openedOnEnter: false,
      typeaheadInputValue: null,
      typeaheadActiveChild: null,
      typeaheadFilteredChildren: React.Children.toArray(_this.props.children),
      typeaheadCurrIndex: -1,
      creatableValue: ''
    };

    _this.componentDidUpdate = function (prevProps, prevState) {
      if (_this.props.hasInlineFilter) {
        _this.refCollection[0] = _this.filterRef.current;
      }

      if (!prevState.openedOnEnter && _this.state.openedOnEnter) {
        _this.refCollection[0].focus();
      }

      if (prevProps.children !== _this.props.children) {
        _this.setState({
          typeaheadFilteredChildren: React.Children.toArray(_this.props.children)
        });
      }

      if (prevProps.selections !== _this.props.selections && _this.props.variant === SelectVariant.typeahead) {
        _this.setState({
          typeaheadInputValue: _this.props.selections
        });
      }
    };

    _this.onEnter = function () {
      _this.setState({
        openedOnEnter: true
      });
    };

    _this.onClose = function () {
      _this.setState({
        openedOnEnter: false,
        typeaheadInputValue: null,
        typeaheadActiveChild: null,
        typeaheadFilteredChildren: React.Children.toArray(_this.props.children),
        typeaheadCurrIndex: -1
      });
    };

    _this.onChange = function (e) {
      var _this$props = _this.props,
          onFilter = _this$props.onFilter,
          isCreatable = _this$props.isCreatable,
          onCreateOption = _this$props.onCreateOption,
          createText = _this$props.createText,
          noResultsFoundText = _this$props.noResultsFoundText,
          children = _this$props.children;
      var typeaheadFilteredChildren;

      if (onFilter) {
        typeaheadFilteredChildren = onFilter(e) || children;
      } else {
        var input;

        try {
          input = new RegExp(e.target.value.toString(), 'i');
        } catch (err) {
          input = new RegExp(e.target.value.toString().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
        }

        typeaheadFilteredChildren = e.target.value.toString() !== '' ? React.Children.toArray(_this.props.children).filter(function (child) {
          return _this.getDisplay(child.props.value.toString(), 'text').search(input) === 0;
        }) : React.Children.toArray(_this.props.children);
      }

      if (!typeaheadFilteredChildren) {
        typeaheadFilteredChildren = [];
      }

      if (typeaheadFilteredChildren.length === 0) {
        !isCreatable && typeaheadFilteredChildren.push(React.createElement(SelectOption, {
          isDisabled: true,
          key: 0,
          value: noResultsFoundText,
          isNoResultsOption: true
        }));
      }

      if (isCreatable && e.target.value !== '') {
        var newValue = e.target.value;
        typeaheadFilteredChildren.push(React.createElement(SelectOption, {
          key: 0,
          value: newValue,
          onClick: function onClick() {
            return onCreateOption && onCreateOption(newValue);
          }
        }, createText, " \"", newValue, "\""));
      }

      _this.setState({
        typeaheadInputValue: e.target.value,
        typeaheadCurrIndex: -1,
        typeaheadFilteredChildren: typeaheadFilteredChildren,
        typeaheadActiveChild: null,
        creatableValue: e.target.value
      });

      _this.refCollection = [];
    };

    _this.onClick = function (e) {
      e.stopPropagation();
    };

    _this.clearSelection = function (e) {
      e.stopPropagation();

      _this.setState({
        typeaheadInputValue: null,
        typeaheadActiveChild: null,
        typeaheadFilteredChildren: React.Children.toArray(_this.props.children),
        typeaheadCurrIndex: -1
      });
    };

    _this.sendRef = function (ref, index) {
      _this.refCollection[index] = ref;
    };

    _this.handleArrowKeys = function (index, position) {
      keyHandler(index, 0, position, _this.refCollection, _this.refCollection);
    };

    _this.handleFocus = function () {
      if (!_this.props.isOpen) {
        _this.props.onToggle(true);
      }
    };

    _this.handleTypeaheadKeys = function (position) {
      var _this$props2 = _this.props,
          isOpen = _this$props2.isOpen,
          isCreatable = _this$props2.isCreatable,
          createText = _this$props2.createText;
      var _this$state = _this.state,
          typeaheadActiveChild = _this$state.typeaheadActiveChild,
          typeaheadCurrIndex = _this$state.typeaheadCurrIndex;

      if (isOpen) {
        if (position === 'enter' && (typeaheadActiveChild || _this.refCollection[0])) {
          _this.setState({
            typeaheadInputValue: typeaheadActiveChild && typeaheadActiveChild.innerText || _this.refCollection[0].innerText
          });

          if (typeaheadActiveChild) {
            typeaheadActiveChild.click();
          } else {
            _this.refCollection[0].click();
          }
        } else {
          var nextIndex;

          if (typeaheadCurrIndex === -1 && position === 'down') {
            nextIndex = 0;
          } else if (typeaheadCurrIndex === -1 && position === 'up') {
            nextIndex = _this.refCollection.length - 1;
          } else {
            nextIndex = getNextIndex(typeaheadCurrIndex, position, _this.refCollection);
          }

          _this.setState({
            typeaheadCurrIndex: nextIndex,
            typeaheadActiveChild: _this.refCollection[nextIndex],
            typeaheadInputValue: isCreatable && _this.refCollection[nextIndex].innerText.includes(createText) ? _this.state.creatableValue : _this.refCollection[nextIndex].innerText
          });
        }
      }
    };

    _this.getDisplay = function (value) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'node';

      if (!value) {
        return;
      }

      var item = _this.props.isGrouped ? React.Children.toArray(_this.props.children).reduce(function (acc, curr) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(React.Children.toArray(curr.props.children)));
      }, []).find(function (child) {
        return child.props.value.toString() === value.toString();
      }) : React.Children.toArray(_this.props.children).find(function (child) {
        return child.props.value.toString() === value.toString();
      });

      if (item) {
        if (item && item.props.children) {
          if (type === 'node') {
            return item.props.children;
          }

          return _this.findText(item);
        }

        return item.props.value.toString();
      }

      return value;
    };

    _this.findText = function (item) {
      if (!item.props || !item.props.children) {
        if (typeof item !== 'string') {
          return '';
        }

        return item;
      }

      if (typeof item.props.children === 'string') {
        return item.props.children;
      }

      var multi = [];
      React.Children.toArray(item.props.children).forEach(function (child) {
        return multi.push(_this.findText(child));
      });
      return multi.join('');
    };

    _this.generateSelectedBadge = function () {
      var _this$props3 = _this.props,
          customBadgeText = _this$props3.customBadgeText,
          selections = _this$props3.selections;

      if (customBadgeText !== null) {
        return customBadgeText;
      }

      if (Array.isArray(selections) && selections.length > 0) {
        return selections.length;
      }

      return null;
    };

    return _this;
  }

  _createClass(Select, [{
    key: "extendTypeaheadChildren",
    value: function extendTypeaheadChildren(typeaheadActiveChild) {
      var _this2 = this;

      return this.state.typeaheadFilteredChildren.map(function (child) {
        return React.cloneElement(child, {
          isFocused: typeaheadActiveChild && (typeaheadActiveChild.innerText === _this2.getDisplay(child.props.value.toString(), 'text') || _this2.props.isCreatable && typeaheadActiveChild.innerText === "{createText} \"".concat(child.props.value, "\""))
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _a = this.props,
          children = _a.children,
          className = _a.className,
          customContent = _a.customContent,
          variant = _a.variant,
          direction = _a.direction,
          onToggle = _a.onToggle,
          onSelect = _a.onSelect,
          onClear = _a.onClear,
          toggleId = _a.toggleId,
          isOpen = _a.isOpen,
          isGrouped = _a.isGrouped,
          isPlain = _a.isPlain,
          isDisabled = _a.isDisabled,
          selectionsProp = _a.selections,
          typeAheadAriaLabel = _a.typeAheadAriaLabel,
          clearSelectionsAriaLabel = _a.clearSelectionsAriaLabel,
          toggleAriaLabel = _a.toggleAriaLabel,
          removeSelectionAriaLabel = _a.removeSelectionAriaLabel,
          ariaLabel = _a['aria-label'],
          ariaLabelledBy = _a['aria-labelledby'],
          placeholderText = _a.placeholderText,
          width = _a.width,
          maxHeight = _a.maxHeight,
          toggleIcon = _a.toggleIcon,
          ouiaId = _a.ouiaId,
          hasInlineFilter = _a.hasInlineFilter,
          isCheckboxSelectionBadgeHidden = _a.isCheckboxSelectionBadgeHidden,
          inlineFilterPlaceholderText = _a.inlineFilterPlaceholderText,
          onFilter = _a.onFilter,
          onCreateOption = _a.onCreateOption,
          isCreatable = _a.isCreatable,
          createText = _a.createText,
          noResultsFoundText = _a.noResultsFoundText,
          customBadgeText = _a.customBadgeText,
          props = __rest(_a, ["children", "className", "customContent", "variant", "direction", "onToggle", "onSelect", "onClear", "toggleId", "isOpen", "isGrouped", "isPlain", "isDisabled", "selections", "typeAheadAriaLabel", "clearSelectionsAriaLabel", "toggleAriaLabel", "removeSelectionAriaLabel", 'aria-label', 'aria-labelledby', "placeholderText", "width", "maxHeight", "toggleIcon", "ouiaId", "hasInlineFilter", "isCheckboxSelectionBadgeHidden", "inlineFilterPlaceholderText", "onFilter", "onCreateOption", "isCreatable", "createText", "noResultsFoundText", "customBadgeText"]);

      var _this$state2 = this.state,
          openedOnEnter = _this$state2.openedOnEnter,
          typeaheadInputValue = _this$state2.typeaheadInputValue,
          typeaheadActiveChild = _this$state2.typeaheadActiveChild,
          typeaheadFilteredChildren = _this$state2.typeaheadFilteredChildren;
      var selectToggleId = toggleId || "pf-toggle-id-".concat(currentId++);
      var selections = Array.isArray(selectionsProp) ? selectionsProp : [selectionsProp];
      var hasAnySelections = Boolean(selections[0] && selections[0] !== '');
      var childPlaceholderText = null;

      if (!customContent) {
        if (!hasAnySelections && !placeholderText) {
          var childPlaceholder = React.Children.toArray(children).filter(function (child) {
            return child.props.isPlaceholder === true;
          });
          childPlaceholderText = childPlaceholder[0] && this.getDisplay(childPlaceholder[0].props.value, 'node') || children[0] && this.getDisplay(children[0].props.value, 'node');
        }
      }

      var hasOnClear = onClear !== Select.defaultProps.onClear;
      var clearBtn = React.createElement("button", {
        className: css(buttonStyles.button, buttonStyles.modifiers.plain, styles.selectToggleClear),
        onClick: function onClick(e) {
          _this3.clearSelection(e);

          onClear(e);
        },
        "aria-label": clearSelectionsAriaLabel,
        type: "button",
        disabled: isDisabled
      }, React.createElement(TimesCircleIcon, {
        "aria-hidden": true
      }));
      var selectedChips = null;

      if (variant === SelectVariant.typeaheadMulti) {
        selectedChips = React.createElement(ChipGroup, null, selections && selections.map(function (item) {
          return React.createElement(Chip, {
            key: item,
            onClick: function onClick(e) {
              return onSelect(e, item);
            },
            closeBtnAriaLabel: removeSelectionAriaLabel
          }, _this3.getDisplay(item, 'node'));
        }));
      }

      var filterWithChildren = children;

      if (hasInlineFilter) {
        var filterBox = React.createElement(React.Fragment, null, React.createElement("div", {
          key: "inline-filter",
          className: css(styles.selectMenuSearch)
        }, React.createElement("input", {
          key: "inline-filter-input",
          type: "search",
          className: css(formStyles.formControl, formStyles.modifiers.search),
          onChange: this.onChange,
          placeholder: inlineFilterPlaceholderText,
          onKeyDown: function onKeyDown(event) {
            if (event.key === KeyTypes.ArrowUp) {
              _this3.handleArrowKeys(0, 'up');
            } else if (event.key === KeyTypes.ArrowDown) {
              _this3.handleArrowKeys(0, 'down');
            }
          },
          ref: this.filterRef,
          autoComplete: "off"
        })), React.createElement(Divider, {
          key: "inline-filter-divider"
        }));
        this.refCollection[0] = this.filterRef.current;
        filterWithChildren = [filterBox].concat(_toConsumableArray(typeaheadFilteredChildren)).map(function (option, index) {
          return React.cloneElement(option, {
            key: index
          });
        });
      }

      var variantProps;
      var variantChildren;

      if (customContent) {
        variantProps = {
          selected: selections,
          openedOnEnter: openedOnEnter,
          isCustomContent: true
        };
        variantChildren = customContent;
      } else {
        switch (variant) {
          case 'single':
            variantProps = {
              selected: selections[0],
              openedOnEnter: openedOnEnter
            };
            variantChildren = children;
            break;

          case 'checkbox':
            variantProps = {
              checked: selections,
              isGrouped: isGrouped,
              hasInlineFilter: hasInlineFilter
            };
            variantChildren = filterWithChildren;
            break;

          case 'typeahead':
            variantProps = {
              selected: selections[0],
              openedOnEnter: openedOnEnter
            };
            variantChildren = this.extendTypeaheadChildren(typeaheadActiveChild);
            break;

          case 'typeaheadmulti':
            variantProps = {
              selected: selections,
              openedOnEnter: openedOnEnter
            };
            variantChildren = this.extendTypeaheadChildren(typeaheadActiveChild);
            break;
        }
      }

      return React.createElement("div", Object.assign({
        className: css(styles.select, isOpen && styles.modifiers.expanded, direction === SelectDirection.up && styles.modifiers.top, className),
        ref: this.parentRef,
        style: {
          width: width
        }
      }, getOUIAProps('Select', ouiaId)), React.createElement(SelectContext.Provider, {
        value: {
          onSelect: onSelect,
          onClose: this.onClose,
          variant: variant
        }
      }, React.createElement(SelectToggle, {
        id: selectToggleId,
        parentRef: this.parentRef,
        isOpen: isOpen,
        isPlain: isPlain,
        onToggle: onToggle,
        onEnter: this.onEnter,
        onClose: this.onClose,
        variant: variant,
        "aria-labelledby": "".concat(ariaLabelledBy || '', " ").concat(selectToggleId),
        "aria-label": toggleAriaLabel,
        handleTypeaheadKeys: this.handleTypeaheadKeys,
        isDisabled: isDisabled,
        hasClearButton: hasOnClear
      }, customContent && React.createElement("div", {
        className: css(styles.selectToggleWrapper)
      }, toggleIcon && React.createElement("span", {
        className: css(styles.selectToggleIcon)
      }, toggleIcon), React.createElement("span", {
        className: css(styles.selectToggleText)
      }, placeholderText)), variant === SelectVariant.single && !customContent && React.createElement(React.Fragment, null, React.createElement("div", {
        className: css(styles.selectToggleWrapper)
      }, toggleIcon && React.createElement("span", {
        className: css(styles.selectToggleIcon)
      }, toggleIcon), React.createElement("span", {
        className: css(styles.selectToggleText)
      }, this.getDisplay(selections[0], 'node') || placeholderText || childPlaceholderText)), hasOnClear && hasAnySelections && clearBtn), variant === SelectVariant.checkbox && !customContent && React.createElement(React.Fragment, null, React.createElement("div", {
        className: css(styles.selectToggleWrapper)
      }, toggleIcon && React.createElement("span", {
        className: css(styles.selectToggleIcon)
      }, toggleIcon), React.createElement("span", {
        className: css(styles.selectToggleText)
      }, placeholderText), !isCheckboxSelectionBadgeHidden && hasAnySelections && React.createElement("div", {
        className: css(styles.selectToggleBadge)
      }, React.createElement("span", {
        className: css(badgeStyles.badge, badgeStyles.modifiers.read)
      }, this.generateSelectedBadge()))), hasOnClear && hasAnySelections && clearBtn), variant === SelectVariant.typeahead && !customContent && React.createElement(React.Fragment, null, React.createElement("div", {
        className: css(styles.selectToggleWrapper)
      }, toggleIcon && React.createElement("span", {
        className: css(styles.selectToggleIcon)
      }, toggleIcon), React.createElement("input", {
        className: css(formStyles.formControl, styles.selectToggleTypeahead),
        "aria-activedescendant": typeaheadActiveChild && typeaheadActiveChild.id,
        id: "".concat(selectToggleId, "-select-typeahead"),
        "aria-label": typeAheadAriaLabel,
        placeholder: placeholderText,
        value: typeaheadInputValue !== null ? typeaheadInputValue : this.getDisplay(selections[0], 'text') || '',
        type: "text",
        onClick: this.onClick,
        onChange: this.onChange,
        onFocus: this.handleFocus,
        autoComplete: "off",
        disabled: isDisabled
      })), (selections[0] || typeaheadInputValue) && clearBtn), variant === SelectVariant.typeaheadMulti && !customContent && React.createElement(React.Fragment, null, React.createElement("div", {
        className: css(styles.selectToggleWrapper)
      }, toggleIcon && React.createElement("span", {
        className: css(styles.selectToggleIcon)
      }, toggleIcon), selections && Array.isArray(selections) && selections.length > 0 && selectedChips, React.createElement("input", {
        className: css(formStyles.formControl, styles.selectToggleTypeahead),
        "aria-activedescendant": typeaheadActiveChild && typeaheadActiveChild.id,
        id: "".concat(selectToggleId, "-select-multi-typeahead-typeahead"),
        "aria-label": typeAheadAriaLabel,
        placeholder: placeholderText,
        value: typeaheadInputValue !== null ? typeaheadInputValue : '',
        type: "text",
        onChange: this.onChange,
        onClick: this.onClick,
        onFocus: this.handleFocus,
        autoComplete: "off",
        disabled: isDisabled
      })), (selections && selections.length > 0 || typeaheadInputValue) && clearBtn)), isOpen && React.createElement(SelectMenu, Object.assign({}, props, {
        isGrouped: isGrouped,
        selected: selections
      }, variantProps, {
        openedOnEnter: openedOnEnter,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        sendRef: this.sendRef,
        keyHandler: this.handleArrowKeys,
        maxHeight: maxHeight
      }), variantChildren)));
    }
  }]);

  return Select;
}(React.Component);
Select.defaultProps = {
  children: [],
  className: '',
  direction: SelectDirection.down,
  toggleId: null,
  isOpen: false,
  isGrouped: false,
  isPlain: false,
  isDisabled: false,
  isCreatable: false,
  'aria-label': '',
  'aria-labelledby': '',
  typeAheadAriaLabel: '',
  clearSelectionsAriaLabel: 'Clear all',
  toggleAriaLabel: 'Options menu',
  removeSelectionAriaLabel: 'Remove',
  selections: [],
  createText: 'Create',
  placeholderText: '',
  noResultsFoundText: 'No results found',
  variant: SelectVariant.single,
  width: '',
  onClear: function onClear() {
    return undefined;
  },
  onCreateOption: function onCreateOption() {
    return undefined;
  },
  toggleIcon: null,
  onFilter: null,
  customContent: null,
  hasInlineFilter: false,
  inlineFilterPlaceholderText: null,
  customBadgeText: null
};